import { css, keyframes } from '@emotion/react'
import styled from '@emotion/styled'
import convert from 'color-convert'

import { Flex } from '../layout/Flex'

const fadeIn = keyframes`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`

export type DimmerVariant = 'darken' | 'blend' | 'solid'

export interface DimmerProps {
  variant?: DimmerVariant
}

const Dimmer = styled(Flex)<DimmerProps>`
  width: 100%;
  inset: 0 0 0 0;
  position: fixed;
  z-index: 99999;
  animation: ${fadeIn} 150ms forwards;
  flex-direction: column;
  background: ${props => props.theme.arcadeColors.semantic.backgroundDimmer};

  ${props =>
    props.variant === 'blend' &&
    css`
      background: rgba(${convert.hex.rgb(props.theme.arcadeColors.semantic.backgroundApp).join(',')}, 90%);
    `}

  ${props =>
    props.variant === 'solid' &&
    css`
      background: ${props.theme.arcadeColors.semantic.backgroundApp};
    `}
`

export default Dimmer
